import { render, staticRenderFns } from "./BoardItems.vue?vue&type=template&id=12559942&scoped=true&"
import script from "./BoardItems.vue?vue&type=script&lang=js&"
export * from "./BoardItems.vue?vue&type=script&lang=js&"
import style0 from "./BoardItems.vue?vue&type=style&index=0&id=12559942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12559942",
  null
  
)

export default component.exports